import { getElementById } from "../toggle/Utils";

export type DummyExperimentVariation = "StatusQuo" | "DummyVar1" | "DummyVar2";
export type RetailerOttoToggleExperimentVariation = "StatusQuo" | "Toggle";
export type UseNewModelForPriceRangesExperimentVariation = "StatusQuo" | "NewChips";
export type NewConceptFilterButtonsExperimentVariation = "StatusQuo" | "TestGroup";
export type NextBestFacetExperimentVariation = "StatusQuo" | "ValueFacet" | "FacetValue" | "FacetOnly";
export type FilterbarExperimentVariation = "StatusQuo" | "Filterbar";

export type Experiments = {
  [key: string]:
    | DummyExperimentVariation
    | RetailerOttoToggleExperimentVariation
    | UseNewModelForPriceRangesExperimentVariation
    | NewConceptFilterButtonsExperimentVariation
    | NextBestFacetExperimentVariation
    | undefined;
  d666?: DummyExperimentVariation;
  e3474?: UseNewModelForPriceRangesExperimentVariation;
  e3568?: NewConceptFilterButtonsExperimentVariation;
  e3792?: NextBestFacetExperimentVariation;
  e3911?: FilterbarExperimentVariation;
};

let experiments: Experiments;

export function initExperiments() {
  const data = getElementById("leafcutter_experiments")?.dataset;
  if (data) {
    experiments = {};
    for (const key in data) {
      const variation = data[key];
      if (variation) {
        (experiments as Experiments)[key.toLowerCase()] = variation as Experiments[keyof Experiments];
      }
    }
  }
}

/**
 *
 */
export function updateExperiment<T extends keyof Experiments>(experiment: T, variation: Experiments[T]) {
  experiments[experiment] = variation;
}

export function getActiveVariation<T extends keyof Experiments>(
  exp: T,
  defaultVariation?: Experiments[T],
): Experiments[T] | undefined {
  return experiments ? experiments[exp] || defaultVariation : defaultVariation;
}

export function isActiveVariation<T extends keyof Experiments>(exp: T, variation: Experiments[T]): boolean {
  return experiments ? experiments[exp] === variation : false;
}
